/// <amd-module name="TFS/Token/PatTokenPage/Components/Common/ScopeGrouping" />
import { ScopeData, ScopeGrouping } from 'Generated/Contracts';
import { FontSizes, FontWeights, mergeStyleSets, ITheme, getTheme } from "OfficeFabric/Styling";
import { memoize } from "VSS/Core/Util/Memoize";
import { Checkbox } from "VSSUI/Checkbox";
import * as React from 'react';
import ScopeUtils from 'Utils/ScopeUtils';

export interface IScopeGroupingProps {
    group: ScopeGrouping,
    selectedScopes: ScopeData[];
    onCheckboxChange: (scope: ScopeData, group: ScopeGrouping, isChecked?: boolean) => void
}

export default class ScopeGroupings extends React.PureComponent<IScopeGroupingProps, {}> {
    constructor(props: IScopeGroupingProps) {
        super(props);
    }

    @memoize
    private static getStyles(theme: ITheme) {
        const { palette } = theme;
        return mergeStyleSets({
            groupingContainer: {
                display: "flex",
                flexDirection: "column",
                padding: "12px",
            },
            groupingTitle: {
                fontSize: FontSizes.medium,
                fontWeight: FontWeights.bold
            },
            groupingDescription: {
                fontSize: FontSizes.smallPlus
            },
            checkboxContainer: {
                display: "flex",
                flexDirection: "row",
                padding: "12px 0px 12px 0px",
                alignItems: "center",
            },
            checkbox: {
                marginRight: "12px",
            }
        })
    }

    public render() {
        const styles = this.getStyles();
        const { group } = this.props;

        return (
            <div className={styles.groupingContainer}>
                <span className={styles.groupingTitle}>{group.name}</span>
                <span className={styles.groupingDescription}>{group.description}</span>
                {this.renderScopeCheckboxes(group.name, group.scopes)}
            </div>
        )
    }

    // returns a div with a checkbox for each scope in the group
    private renderScopeCheckboxes = (groupName: string, scopes: ScopeData[]) => {
        const styles = this.getStyles();

        return (
            <div className={styles.checkboxContainer}>
                {scopes.map(scope => {
                    return (
                        <div className={styles.checkbox} key={scope.key}>
                            <Checkbox
                                ariaLabel={this.generateAriaLabel(groupName, scope.name)}
                                className={styles.checkbox}
                                label={scope.name}
                                disabled={this.isDisabled(scope)}
                                checked={this.isChecked(scope)}
                                onChange={(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, checked: boolean) => this.props.onCheckboxChange(scope, this.props.group, checked)}
                            />
                        </div>
                    )
                })}
            </div>
        )
    }

    private generateAriaLabel = (scopeKey: string, scopeName: string) : string => {
        return scopeKey + " " + scopeName;
    }

    private isChecked = (scope: ScopeData): boolean => {
        const { selectedScopes } = this.props;
        return selectedScopes.filter(item => item.key === scope.key).length === 1 ||
            this.isDisabled(scope);
    }

    private isDisabled = (scope: ScopeData): boolean => {
        const { selectedScopes, group } = this.props;
        return selectedScopes.filter(item => ScopeUtils.isParentOf(item, scope, group.scopes)).length !== 0;
    }

    private getStyles() {
        const theme = getTheme();
        return ScopeGroupings.getStyles(theme);
    }
}
